import {
  CheckCircle,
  Info,
  Warning,
  XCircle,
} from '@phosphor-icons/react';

export const SEVERITY_CONFIG = {
  info: { label: 'Info', color: 'bg-blue-100 text-blue-800', icon: Info },
  warning: { label: 'Warning', color: 'bg-amber-100 text-amber-800', icon: Warning },
  error: { label: 'Error', color: 'bg-red-100 text-red-800', icon: XCircle },
  critical: { label: 'Critical', color: 'bg-red-200 text-red-900', icon: XCircle },
};

// Defensive default so callers don't have to nil-check; chosen to keep the
// table neutral-looking when an unknown severity arrives from the backend.
SEVERITY_CONFIG.unknown = { label: 'Unknown', color: 'bg-slate-100 text-slate-700', icon: CheckCircle };

export const ACTION_LABELS = {
  'auth.login': 'User Login',
  'auth.logout': 'User Logout',
  'auth.register': 'User Registration',
  create: 'Create',
  read: 'View',
  update: 'Update',
  delete: 'Delete',
  import: 'Import',
  export: 'Export',
  batch_submit: 'Batch Submit',
  submit_claim: 'Submit Claim',
  verify_eligibility: 'Verify Eligibility',
  process_remittance: 'Process Remittance',
  validate_address: 'Validate Address',
  generate_report: 'Generate Report',
  role_change: 'Role Change',
  permission_change: 'Permission Change',
  api_request: 'API Request',
};

export const DATE_PRESETS = [
  { value: 'today', label: 'Today' },
  { value: 'week', label: 'This Week' },
  { value: 'month', label: 'This Month' },
  { value: 'last7', label: 'Last 7 Days' },
  { value: 'last30', label: 'Last 30 Days' },
  { value: 'all', label: 'All Time' },
];

/**
 * Resolve a date preset to an ISO `{start, end}` window.
 * `all` returns nulls so the caller can omit the params entirely.
 */
export function resolveDateRange(preset) {
  const now = new Date();
  let start = null;
  let end = now.toISOString();

  switch (preset) {
    case 'today':
      start = new Date(now.setHours(0, 0, 0, 0)).toISOString();
      break;
    case 'week': {
      const dayOfWeek = now.getDay();
      const diff = now.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
      start = new Date(now.setDate(diff)).toISOString();
      break;
    }
    case 'month':
      start = new Date(now.getFullYear(), now.getMonth(), 1).toISOString();
      break;
    case 'last7':
      start = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString();
      break;
    case 'last30':
      start = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString();
      break;
    case 'all':
      start = null;
      end = null;
      break;
    default:
      break;
  }
  return { start, end };
}
